import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

import "./assets/stylesheets/index.css";
import "./assets/stylesheets/about.css";
import "./assets/stylesheets/homePageMobile.css";
import "./assets/stylesheets/root.css";
import "./assets/stylesheets/serviceCard.css";
import "./assets/stylesheets/features.css";
import "./assets/stylesheets/profile.css";
// import "./assets/stylesheets/testimonial.css";
import "./assets/stylesheets/howItWorks.css";
import "./assets/stylesheets/callToAction.css";
import "./assets/stylesheets/profileDetails.css";
import "./assets/stylesheets/serviceDetails.css";
import "./assets/stylesheets/cancellationPolicy.css";
import "./assets/stylesheets/spotlightCard.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>
);
